module.exports = __webpack_public_path__ + "d2c3baf7e72d196c5090ac7b3abd0a2a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/TORN.svg
// module id = MAvv
// module chunks = 0